import { css } from 'emotion'
import searchBGD from './../../static/search.jpg'
import { Colors, Label, Easings } from '../'

export const SearchStyle = (search) => css({
  position: 'relative',
  background: `#000000 url(${searchBGD}) no-repeat left center fixed`,
  backgroundSize: 'contain',
  overflowX: 'hidden',
  minHeight: 'calc(100vh - 120px)',
  '.home-search-list': {
    display: search ? 'block' : 'none'
  },
  '.home-featured': {
    display: !search ? 'block' : 'none'
  },
  '.card h2': {
    height: 42
  },
  '@media (min-width: 1024px)': {
    minHeight: 'calc(100vh - 160px)',
  }
})

export const searchListStyle = (ready) => css({
  margin: '2rem 20px',
  '.search-transition': {
    opacity: ready ? 1 : 0,
    transform: `translateY(${ ready ? 0 : 10 }px)`,
    transition: 'all 400ms ease',
  },
  '.search-load': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '1rem',
    opacity: ready ? 0 : 1,
    transition: 'all 400ms ease',
    'svg': {
      'path': {
        stroke: '#ffffff',
      },
      'circle': {
        fill: '#ffffff',
      },
    },
    // background: 'rgba(255, 255, 255, 0.5)',
  },
  '@media (min-width: 1024px)': {
    margin: '2rem 8rem 4rem',
  },
  '.product-list': {
    marginTop: '2rem',
  },
  '.filter-item .dropdown-label': {
    '@media (min-width: 1024px)': {
      color: Colors.grey,
      transition: 'color 200ms ease',
      'svg': {
        transition: 'color 200ms ease',
      },
      '&:hover': {
        color: 'white',
        'svg': {
          fill: 'white',
        }
      }
    }
  },
  '.results, .no-results': {
    ...Label,
    color: Colors.mediumGrey
  },
  '.categories-filter': {
    margin: '0rem 0px 2rem',
    '@media (min-width: 1024px)': {
      margin: '1rem 0px 2rem',
    },
    'li': {
      color: 'white',
      padding: '1rem 0px',
      textTransform: 'uppercase',
      fontWeight: 800,
      position:"relative",
      margin: '0 1rem',
      opacity: 0.5,
      cursor: 'pointer',
      transition: 'opacity 200ms ease',
      whiteSpace: 'nowrap',

      '&:first-child': {
        marginLeft: 0
      },

      '&:after': {
        content: '""',
        background: 'white',
        height: 4,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        transform: 'scaleX(0)',
        transition: `transform 400ms ${Easings.customEase}`,
        transformOrigin: 'center left',
      },
      '&:hover': {
        opacity: 1,
      },
      '&.active' : {
        opacity: 1,
        '&:after' : {
          transform: 'scaleX(1)',
        }
      }
    },
  },
  '.filter': {
    margin: '0px -20px',
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/search.js